import { useReduxLoading } from '@core/hooks';
import { useApiUtils } from '@core/util/apiUtils';
import FusePageCarded from '@fuse/core/FusePageCarded';
import { EmpresaCadastroModal } from 'app/main/empresa/modal';
import { confirmarAlert } from 'app/services/alerts';
import empresaApi from 'app/services/api/empresaApi';
import * as Actions from 'app/store/actions';
import { GlobalContext } from 'app/store/globalcontext';
import { initializeReactGA } from 'app/utils/analyticsUtil';
import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { EmpresaTableContext, EmpresaTableProvider } from './EmpresaTableContext';
import EmpresaSearchHeader from './components/EmpresaSearchHeader';
import EmpresaTable from './components/EmpresaTable';
import { EmpresaModais } from './modal';
import EmpresaVisualizacaoModal from './modal/visualizar/EmpresaVisualizarModal';

const Empresa = () => {
  const [modal, setModalContextoEmpresa] = useContext(EmpresaTableContext).modal;
  const [, setEmpresa] = useContext(GlobalContext).empresa;
  const [loading, setLoading] = useContext(EmpresaTableContext).loading;
  const [, setEmpresas] = useContext(EmpresaTableContext).empresas;
  const [search, setSearch] = useContext(EmpresaTableContext).search;
  const [, setTotalElements] = useContext(EmpresaTableContext).totalElements;
  const [, setSize] = useContext(EmpresaTableContext).size;
  const [, setModal] = useContext(GlobalContext).modal;

  useReduxLoading(loading);

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  const history = useHistory();

  const initialPage = {
    page: 0,
    query: '',
    size: 15,
    sort: 'pessoa.nome,asc',
  };

  const empresaCadastroDefault = {
    pessoa: {
      tipoPessoa: 'JURIDICA',
    },
    ativo: true,
  };

  const fetchData = (s) => {
    if (s) {
      s.query = search?.query;
    }
    fetchEmpresas(s);
  };

  const fetchEmpresas = async (search = initialPage) => {
    setLoading(true);
    setSearch(search);

    try {
      const response = await empresaApi.buscarEmpresasPorUsuario(search);
      setEmpresas(response.data.content);
      setTotalElements(response.data.totalElements);
      setSize(response.data.size);
    } catch (error) {
      apiUtils.handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  const onInit = () => {
    initializeReactGA(history?.location?.pathname);
    fetchEmpresas();
  };

  const chamarModalAlterarPlano = () => {
    setModal(EmpresaModais.alteracaoPlanoComercial);
  };

  const confirmarAlteracaoPlano = () => {
    confirmarAlert({
      confirmar: chamarModalAlterarPlano,
      titulo: 'Seu plano atual não permite cadastro de mais empresas.',
      mensagem: 'Você deseja conhecer mais sobre esses planos?',
    });
  };

  const cadastrarEmpresa = async () => {
    try {
      setLoading(true);
      await empresaApi.limiteEmpresa(false);
      setEmpresa(empresaCadastroDefault);
      setModalContextoEmpresa(EmpresaModais.cadastrarEmpresa);
    } catch (err) {
      confirmarAlteracaoPlano();
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const editarEmpresa = async (id) => {
    await buscarEmpresa(id);
    setModalContextoEmpresa(EmpresaModais.cadastrarEmpresa);
  };

  async function buscarEmpresa(id) {
    try {
      setLoading(true);
      const respEmpresa = await empresaApi.buscar(id);

      if (respEmpresa?.data?.logomarcaId) {
        const logomarca = await empresaApi.buscarLogoMarca(respEmpresa?.data?.logomarcaId);
        if (logomarca?.data?.content) {
          respEmpresa.data.logomarca = `data:image/jpeg;charset=utf-8;base64,${logomarca?.data?.content}`;
        }
      }

      setEmpresa(respEmpresa.data);
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(onInit, []);

  return (
    <FusePageCarded
      innerScroll
      header={<EmpresaSearchHeader fetchEmpresas={fetchEmpresas} initialPage={initialPage} />}
      content={
        <>
          <EmpresaTable
            fetchData={fetchData}
            editarEmpresa={editarEmpresa}
            cadastrarEmpresa={cadastrarEmpresa}
            buscarEmpresa={buscarEmpresa}
          />

          <EmpresaCadastroModal fetchData={fetchData} modal={modal} setModalContextoEmpresa={setModalContextoEmpresa} />
          <EmpresaVisualizacaoModal isOrigemEmpresa modal={modal} setModalContextoEmpresa={setModalContextoEmpresa} />
        </>
      }
    />
  );
};

const EmpresaContainer = () => (
  <EmpresaTableProvider>
    <Empresa />
  </EmpresaTableProvider>
);

export default EmpresaContainer;
